import { createRouter, RouterProvider } from '@tanstack/react-router'
import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { SignI18nProvider } from './lib/locale'
import { startQueue } from './lib/offline-queue'
import { routeTree } from './routeTree.gen'
import './styles.css'

/**
 * Entry point. The router is created once and the whole tree sits inside the locale provider, so
 * every route and every shared component reads the same language (ADR 0010).
 */
const router = createRouter({ routeTree, defaultPreload: 'intent' })

/**
 * The submission queue is started here rather than by a screen (M2-08, scope 3): a phone that was
 * closed in a loading bay and reopened at the depot has work waiting for it, and that work has to
 * leave whether or not anybody navigates back to the link it belongs to.
 */
startQueue()

declare module '@tanstack/react-router' {
  interface Register {
    router: typeof router
  }
}

const container = document.getElementById('root')
if (container === null) throw new Error('Missing #root in index.html')

createRoot(container).render(
  <StrictMode>
    <SignI18nProvider>
      <RouterProvider router={router} />
    </SignI18nProvider>
  </StrictMode>,
)
